import { render, staticRenderFns } from "./observed_00.vue?vue&type=template&id=ae5c5cfc&"
import script from "./observed_00.vue?vue&type=script&lang=js&"
export * from "./observed_00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports